"use strict";

var _defineProperty = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CharacterDataImpl = require("./CharacterData-impl").implementation;

var idlUtils = require("../generated/utils");

var NODE_TYPE = require("../node-type");

var CommentImpl =
/*#__PURE__*/
function (_CharacterDataImpl) {
  _inherits(CommentImpl, _CharacterDataImpl);

  function CommentImpl(globalObject, args, privateData) {
    var _this;

    _classCallCheck(this, CommentImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CommentImpl).call(this, globalObject, args, _objectSpread({
      data: args[0],
      ownerDocument: idlUtils.implForWrapper(globalObject._document)
    }, privateData)));
    _this.nodeType = NODE_TYPE.COMMENT_NODE;
    return _this;
  }

  return CommentImpl;
}(CharacterDataImpl);

module.exports = {
  implementation: CommentImpl
};